import { useEffect, useState } from 'react';

import {
    DEFAULT_DEV_ERROR_MESSAGE,
    type DevThrowErrorBoundaryDetail,
    subscribeDevThrowErrorBoundary,
} from '@/utils/devtools/error-boundary-dev-tool';

export default function DevErrorBoundaryProbe() {
    const [pending, setPending] = useState<DevThrowErrorBoundaryDetail | null>(null);

    useEffect(() => subscribeDevThrowErrorBoundary(setPending), []);

    if (pending) {
        throw new Error(pending.message ?? DEFAULT_DEV_ERROR_MESSAGE);
    }

    return null;
}
